// extracted by mini-css-extract-plugin
module.exports = {"ctaWrapper":"Xf-z","subtitle":"Yf-z","wrapper":"Zf-z","leftArrow":"_f-z","rightArrow":"ag-z"};